<form (ngSubmit)="onSubmit()">
  @if (showOutcomeReasons) {
    <div class="d-flex align-items-center">
      <div class="mb-3 w-50 me-2">
        <select class="form-select" [(ngModel)]="formModel.transition" (change)="onTransitionChange()" name="transition">
          <option [ngValue]="null" [selected]="true"> -- Select Outcome -- </option>
          @for (statusOption of transitionOptions; track statusOption) {
            <option [ngValue]="statusOption.value">
              {{ statusOption.display }}
            </option>
          }
        </select>
      </div>
      <div class="mb-3">
        <button type="submit" class="btn btn-primary" [disabled]="!allowSubmit" [hidden]="!formModel.transition">
          <span [hidden]="verificationRequestPending">Process Capture</span>
          <span [hidden]="!verificationRequestPending">
            <fa-icon [icon]="['fas', 'hourglass-half']" size="sm" /> Process Capture
          </span>
        </button>
      </div>
    </div>
  }

  @if (showBlockingReversalExemptionPrompt) {
    <div class="alert alert-danger">
      <strong>There is a reversed capture in the pool of this capture.</strong>
      <div class="form-check">
        <input
          type="checkbox"
          name="blockingReversalExempt"
          [(ngModel)]="formModel.verificationOutcome.blockingReversalExempt"
          (change)="onBlockingReversalExemptChange()"
          class="form-check-input"
          id="blockingReversalExempt" />
        <label class="form-check-label" for="blockingReversalExempt">
          Verify this capture and all related WIP captures even though there is a reversal in the pool.
        </label>
      </div>
    </div>
  }

  @if (showSpecialtyMismatchExemptionPrompt) {
    <div class="alert alert-danger">
      <strong>The selected prescriber's specialty does not match the consult note specialty. Please review the consult note above.</strong>
      <div class="form-check">
        <input
          type="checkbox"
          name="blockingReversalExempt"
          [(ngModel)]="formModel.verificationOutcome.specialtyMismatchExempt"
          (change)="onSpecialtyMismatchExemptChange()"
          class="form-check-input"
          id="specialtyMismatchExempt" />
        <label class="form-check-label" for="specialtyMismatchExempt">
          Verify even though the specialty does not match between prescriber and consult note.
        </label>
      </div>
    </div>
  }

  <app-verification-validation [key]="validationKey" />

  @if (showValidationSummary) {
    <div class="alert alert-danger">
      Capture cannot be verified. Please fix the issues above.
    </div>
  }

  <div [hidden]="!formModel.transition">
    <div [hidden]="!reasonRequired">
      <div class="mb-3">
        <strong>Select Reason</strong>
        @for (reasonOption of reasonOptions; track reasonOption) {
          <div class="form-check my-2">
            <input
              (change)="onRadioStatusReasonChange(reasonOption.value)"
              [id]="reasonOption.value"
              [value]="reasonOption.value"
              [(ngModel)]="formModel.verificationOutcome.statusReason"
              class="form-check-input"
              name="statusReason"
              type="radio"
              />
            <label class="form-check-label" [for]="reasonOption.value"> {{ reasonOption.display }} </label>
          </div>
        }
      </div>
    </div>

    @if (showCeReviewClientNoteInput) {
      <div class="mb-3">
        <label for="ceReviewNote">NOTES FOR REFERRAL AND CONSULT NOTE TASKS</label>
        <textarea
          class="form-control"
          id="ceReviewNote"
          name="ceReviewNote"
          [(ngModel)]="formModel.verificationOutcome.ceReviewNote">
        </textarea>
      </div>
    }
  </div>
  <div class="mb-3">
    <label for="additionalDetails">
      ADDITIONAL DETAILS @if (additionalDetailsRequired) {
      <span class="text-danger">(required)</span>
    }
  </label>
  <div class="mb-2"><em>All additional details for this capture are available on Capture History.</em></div>
  <textarea
    class="form-control phi"
    id="additionalDetails"
    rows="3"
    name="additionalDetails"
    [(ngModel)]="formModel.verificationOutcome.additionalDetails"
    (input)="onAdditionalDetailsChange()"
    placeholder="{{ additionalDetailsPlaceholder }}"
  ></textarea>
  <div [hidden]="formModel.transition" class="mt-3">
    <button class="btn btn-primary" [disabled]="!hasAdditionalDetails">Save Details</button>
  </div>
</div>
@if (nonBlockingReversalRequired) {
  <div
    [ngClass]="{
    'bg-success-subtle': formModel.verificationOutcome.nonBlockingReversal
    }"
    class="form-check p-2 d-inline-block"
    >
    <input
      [disabled]="this.capture.status === reversedStatus"
      type="checkbox"
      name="nonBlockingReversal"
      [(ngModel)]="formModel.verificationOutcome.nonBlockingReversal"
      class="form-check-input mx-2"
      id="nonBlockingReversal" />
    <label class="form-check-label" for="nonBlockingReversal">
      Limit this reversal to the current capture (allow future captures to verify).
    </label>
  </div>
}
</form>
